import { lazyWrap } from '@neptune/shared/common-ui';

export const LazyInitiativePage = lazyWrap(
  async () =>
    (await import(/* webpackChunkName: "initiative" */ './InitiativePage')).InitiativePage,
);
